import { canUseDom as isBrowser } from "./can-use-dom";
/** 兼容服务端 */
export function rem2px(size, scale) {
    if (scale === void 0) { scale = 100; }
    // 非字符串，或者不存在直接返回
    if (typeof size !== "string" || !size) {
        if (size === null || typeof size === "string")
            return;
        return size;
    }
    var result = parseFloat(size);
    // px结尾的直接返回数字
    if (size.endsWith("px")) {
        return result;
    }
    if (isBrowser && window.rem2px) {
        return Number(window.rem2px(result).toFixed(1));
    }
    // 服务端或者没有 rem2px 时
    return Number((result * scale).toFixed(1));
}
